import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    // Get from localStorage or default to 'en'
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem('app_language');
      return stored === 'fr' ? 'fr' : 'en';
    }
    return 'en';
  });

  const setLanguage = (lang) => {
    if (lang === 'en' || lang === 'fr') {
      setLanguageState(lang);
      if (typeof window !== 'undefined') {
        localStorage.setItem('app_language', lang);
      }
    }
  };

  useEffect(() => {
    // Sync with localStorage changes (for testing across tabs)
    const handleStorageChange = (e) => {
      if (e.key === 'app_language' && (e.newValue === 'en' || e.newValue === 'fr')) {
        setLanguageState(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

